module.exports = __webpack_public_path__ + "img/contact-logo_m.455351e4.png";